import React, { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

// Component
import Register from 'components/templates/register';

// Libs and Config
import { routeConfig, appConfig } from 'configs';
import ModalManager from 'libs/ModalManager';

const WithAuth = ({ children }) => {
	const router = useRouter();
	const {authentication} = useSelector(state => state.user);
	const {webConfig} = useSelector(state => state.core);
    const isAuth = authentication?.accessToken ? true : false;
	const { query } = router ?? {};

	const routeObject = useMemo(
		() => Object.values(routeConfig).find(r => r.href === router.route),
		[router],
	);

	useEffect(() => {
		if (!routeObject) return;

		const { private: privateRoute, auth: loginRoute, redirectToHome } = routeObject;

		if (!query.token && !isAuth && privateRoute) {
			if (redirectToHome === false) {
				ModalManager.show({
					content: 
						<Register 
							webConfig={webConfig}
						/>,
					title: '',
					maxWidth: 'sm',
					fullScreenMobile: true,
					hideCloseButton: true,
					closable: false,
				})
			}
			else {
				if (webConfig.lang !== 'fa') {
					router.push(`${appConfig.site_url}?lang=${webConfig.lang}`);
				}
				else {
					router.push(appConfig.site_url);
				}
			}	
		}
		else if (isAuth && loginRoute) {
			const url = router.query.redirect ?? appConfig.site_url;
			router.replace(url.toString());
		}
	}, [isAuth, routeObject, query.token]);

	return children;
};

export default WithAuth;
